// ============================================
// IVISION CRM - Supabase Client Configuration
// File: frontend/src/lib/supabase.js
// ============================================
// Drop this file into your frontend/src/lib/ folder
// Make sure your .env has REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY
// ============================================

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '❌ Missing Supabase environment variables!\n' +
    'Make sure .env has:\n' +
    '  REACT_APP_SUPABASE_URL=https://xxxx.supabase.co\n' +
    '  REACT_APP_SUPABASE_ANON_KEY=eyJhbG...'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Quick connection test - call this from any component to verify
export async function testConnection() {
  try {
    const { data, error } = await supabase.from('tenants').select('count').limit(1);
    if (error) throw error;
    console.log('✅ Supabase connected successfully!');
    return true;
  } catch (err) {
    console.log('⚠️ Supabase connection test:', err.message);
    // Table might not exist yet - that's OK, connection still works
    // Try a simple auth check instead
    const { data: { session } } = await supabase.auth.getSession();
    console.log('✅ Supabase auth is reachable! Session:', session ? 'Active' : 'None');
    return true;
  }
}

export default supabase;
